/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
//@ts-nocheck
import React from 'react';
import {
  HeroSectionDetailWidget,
  IHeroSectionDetailWidgetProps,
} from '../../../../widgets/hero-section-detail-widget-react';

import { ItemSpecMercuryWidget } from '@vlinder-web/item-spec-mercury-widget-react';

export const HeroSection = (props: IHeroSectionDetailWidgetProps) => {
  return (
    <>
      <ItemSpecMercuryWidget {...props} />
    </>
  );
};

HeroSection.defaultProps = {};
